import React from 'react'; // eslint-disable-line

import {
  generateDrinkStats,
  generateCountriesData,
  generateProgrammingLanguageStats,
  generateWinesTastes,
} from '@netsapiens/netsapiens-charts-library';

export default (chart) => {
  const chartData = [];

  switch (chart.type) {
    case 'ResponsiveLine':
      chartData.data = { data: generateDrinkStats(12) };
      break;
    case 'ResponsiveRadar':
      chartData.data = generateWinesTastes();
      break;
    case 'ResponsiveHeatMap':
      chartData.data = {
        data: generateCountriesData(['hot dogs', 'burgers', 'sandwich'], {
          size: 11,
        }),
        keys: ['hot dogs', 'burgers', 'sandwich'],
        indexBy: 'country',
      };
      break;
    case 'ResponsivePie':
      chartData.data = {
        data: generateProgrammingLanguageStats(true, 9).map((d) => ({
          id: d.label,
          ...d,
        })),
      };
      break;
    case 'ResponsiveBubble':
      chartData.data = {
        root: {
          country: 'root',
          children: generateCountriesData(['value'], { size: 24 }),
        },
      };
      break;
    case 'ResponsiveStream':
      chartData.data = {
        data: generateCountriesData(['hot dogs', 'burgers', 'sandwich'], {
          size: 11,
        }),
        keys: ['hot dogs', 'burgers', 'sandwich'],
        indexBy: 'country',
      };
      break;
    case 'ResponsiveBar':
      chartData.data = {
        data: generateCountriesData(['hot dogs', 'burgers', 'sandwich'], {
          size: 11,
        }),
        keys: ['hot dogs', 'burgers', 'sandwich'],
        indexBy: 'country',
      };
      break;
    default:
  }

  return chartData;
};
